import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import get from 'lodash/get';

import SchedulePeriod from './schedulePeriod';
import generateOptionsFromInterval from './generateOptionsFromInterval';

const Schedules = ({ activeTab, minInterval, schedules, setTabTo }) => {
  const hideFutureSchedule = !get(schedules, 'current.endDate');

  const currentDaysTabBtn = classNames('c-label-tab', {
    'is-active': (activeTab === 'current'),
    'is-hidden': hideFutureSchedule,
  });

  const futureDaysTabBtn = classNames('c-label-tab', {
    'is-active': (activeTab === 'future'),
    'is-hidden': hideFutureSchedule,
  });

  const times = generateOptionsFromInterval(minInterval);

  return (
    <div>
      <span className="c-heading c-heading--lightgrey c-wrapper u-pv0">Schedule</span>
      <label
        className={currentDaysTabBtn}
        onClick={setTabTo('current')}
        data-automation-id="schedule-tab-current"
      >
        Current
      </label>
      <label
        className={futureDaysTabBtn}
        onClick={setTabTo('future')}
        data-automation-id="schedule-tab-future"
      >
        Future
      </label>
      <SchedulePeriod
        name="schedules.current"
        times={times}
        isActive={activeTab === 'current' || hideFutureSchedule}
        schedules={schedules}
      />
      <SchedulePeriod
        name="schedules.future"
        times={times}
        isActive={activeTab === 'future' && !hideFutureSchedule}
        schedules={schedules}
      />
    </div>
  );
};

Schedules.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setTabTo: PropTypes.func.isRequired,
  schedules: PropTypes.shape({}),
  minInterval: PropTypes.number,
};

Schedules.defaultProps = {
  minInterval: 15,
  schedules: {},
};

export default Schedules;
